import React from "react";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { useFormikContext } from "formik";
import { usePopupState, bindTrigger, bindPopover } from "material-ui-popup-state/hooks";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";

const styles = {
  yearButton: {
    borderRadius: 5,
    py: 0.5,
    px: 0,
  },
};

const getButtonStyle = isSelected => ({
  color: isSelected ? "white" : "black",
  backgroundColor: isSelected ? "primary.main" : "transparent",
  "&:hover": {
    backgroundColor: isSelected ? "primary.dark" : "action.hover",
  },
});

const getYearDisplay = yearValue => {
  if (yearValue === "N/A") return "N/A";
  if (!yearValue) return "";
  return yearValue;
};

export default function YearPicker({ name, label, disabled, textFieldRef }) {
  const { values, setFieldValue, errors, touched, submitCount } = useFormikContext();
  const popupState = usePopupState({ variant: "popover", popupId: `year-picker-${name}` });
  const errorMessage = errors[name];
  const showError = (touched[name] || submitCount > 0) && errorMessage;

  const handleYearSelect = year => {
    setFieldValue(name, year);
    popupState.close();
  };

  const handleNASelect = () => {
    setFieldValue(name, "N/A");
    popupState.close();
  };

  const startYear = 2020;
  const years = Array.from({ length: 31 }, (_, i) => (startYear + i).toString());

  return (
    <div>
      <TextField
        ref={textFieldRef}
        label={label}
        fullWidth
        size="small"
        value={getYearDisplay(values[name])}
        error={!!showError}
        helperText={showError || ""}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <InsertInvitationIcon color={disabled ? "disabled" : "action"} />
            </InputAdornment>
          ),
        }}
        disabled={disabled}
        {...bindTrigger(disabled ? {} : popupState)}
      />

      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: 280 }}>
          <Grid container spacing={1}>
            {years.map((year, i) => (
              <Grid key={year} size={4}>
                <Button
                  fullWidth
                  variant={values[name] === year ? "contained" : "text"}
                  onClick={() => handleYearSelect(year)}
                  sx={{
                    ...styles.yearButton,
                    ...getButtonStyle(values[name] === year),
                  }}
                >
                  {year}
                </Button>
              </Grid>
            ))}
            <Grid display="flex" justifyContent="center" size={12}>
              <Button
                variant={values[name] === "N/A" ? "contained" : "text"}
                onClick={handleNASelect}
                sx={{
                  ...styles.yearButton,
                  ...getButtonStyle(values[name] === "N/A"),
                }}
              >
                N/A
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </div>
  );
}
